import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { MatarialModule } from "./matarial/matarial.module";
import { TokenStorage } from "./util/token.storage";
import { JwtInterceptor } from "./interceptor/jwt.interceptor";
import { ErrorInterceptor } from "./interceptor/error.interceptor";
import { AuthenticationService } from "./services/authentication.service";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoginComponent } from "./component/root/login/login.component";
import { FooterComponent } from "./component/root/layout/footer/footer.component";
import { HeaderComponent } from "./component/root/layout/header/header.component";
import { ForgotPasswordComponent } from "./component/root/login/forgot-password/forgot-password.component";
import { AddNewPasswordComponent } from "./component/root/login/add-new-password/add-new-password.component";
import { ForgetUsernameComponent } from './component/root/login/forget-username/forget-username.component';
import { WebUtil } from './util/web.util';
import { RoleComponent } from './component/feature/umgr/role/role.component';
import { PrivilegeComponent } from './component/feature/umgr/privilege/privilege.component';
import { ToastrUtil } from './util/toastr.util';
import { MenuPrivilegeDialogComponent } from './component/feature/umgr/privilege/menu-privilege-dialog/menu-privilege-dialog.component';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderHttpModule,
} from "ngx-ui-loader";
import { RolePrivilegeDialogComponent } from './component/feature/umgr/role/role-privilege-dialog/role-privilege-dialog.component';
import { BrowserModule } from "@angular/platform-browser";
import { ShiftDetailsComponent } from './component/feature/shift-details/shift-details.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { SearchLprViolationDialogComponent } from './component/feature/shift-details/search-lpr-violation-dialog/search-lpr-violation-dialog.component';
import { InteractiveGeofenceComponent } from "./component/feature/interactive-geofence/interactive-geofence.component";

import { AgmCoreModule } from '@agm/core';
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { ResetPasswordDialogComponent } from "./component/feature/user/user-reset-dialog/user-reset-dialog.component";
import { ResetPasswordVerify } from "./component/root/login/reset-password-verify/reset-password-verify";

import { environment } from 'src/environments/environment';
import { ZoneManagementComponent } from "./component/feature/zone-management/zone-management.component";
import { ZoneAddDialogComponent } from "./component/feature/zone-management/zone-add-dialog/zone-add-dialog.component";
import { ZoneUpdateDialogComponent } from "./component/feature/zone-management/zone-update-dialog/zone-update-dialog.component";
import { GeofenceComponent } from "./component/feature/geofence/geofence.component";
import { GeofenceAddDialogComponent } from "./component/feature/geofence/geofence-add-dialog/geofence-add-dialog.component";
import { GeofenceUpdateDialogComponent } from "./component/feature/geofence/geofence-update-dialog/geofence-update-dialog.component";
import { ZoneViewDialogComponent } from "./component/feature/geofence/zone-view-dialog/zone-view-dialog.component";
import { PaymentDetailSearchComponent } from './component/feature/payment-detail-search/payment-detail-search.component';
import { InteractiveZoneComponent } from './component/feature/interactive-zone/interactive-zone.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { AllGeofenceComponent } from './component/feature/all-geofence/all-geofence.component';
import { NumplatePaymentSearchComponent } from './component/feature/numplate-payment-search/numplate-payment-search.component';
import { NumplatePermitSearchComponent } from './component/feature/numplate-permit-search/numplate-permit-search.component';
import { MatSortModule, MatTableModule } from "@angular/material";
import { PaymentApiNumplateSearchComponent } from './component/feature/payment-api-numplate-search/payment-api-numplate-search.component';
import { ChartsModule } from 'ng2-charts';
import { ChartShiftDetailComponent } from './component/feature/chart-shift-detail/chart-shift-detail.component';
import { DashboardSuperComponent } from './component/feature/dashboard-super/dashboard-super.component';
import { DashboardOrganizationComponent } from './component/feature/dashboard-organization/dashboard-organization.component';
import { ChartDailyShiftDetailsComponent } from './component/feature/chart-daily-shift-details/chart-daily-shift-details.component';
import { GeofenceFileUploaderComponent } from './component/feature/geofence/geofence-file-uploader/geofence-file-uploader.component';
import { ZoneFileUploaderComponent } from './component/feature/zone-management/zone-file-uploader/zone-file-uploader.component';
import { GeofenceDetailFileUploaderComponent } from './component/feature/geofence/geofence-detail-file-uploader/geofence-detail-file-uploader.component';
import { CitationManagementComponent } from './component/feature/citation-management/citation-management.component';
import { CitationViewDialogComponent } from './component/feature/citation-management/citation-view-dialog/citation-view-dialog.component';
import { EnforcementVehicleComponent } from './component/feature/enforcement-vehicle/enforcement-vehicle.component';
import { VehicleAddDialogComponent } from './component/feature/enforcement-vehicle/vehicle-add-dialog/vehicle-add-dialog.component';
import { VehicleUpdateDialogComponent } from './component/feature/enforcement-vehicle/vehicle-update-dialog/vehicle-update-dialog.component';
import { EventManagementComponent } from './component/feature/event-management/event-management.component';
import { EventPeoDialogComponent } from './component/feature/event-management/event-peo-dialog/event-peo-dialog.component';
import { PaymentsTestingComponent } from './component/feature/payments-testing/payments-testing.component';
import { PaymentTestingFileUploaderComponent } from './component/feature/payments-testing/payment-testing-file-uploader/payment-testing-file-uploader.component';
import { DashboardComponent } from './component/feature/dashboard/dashboard.component';
import { NgCircleProgressModule } from "ng-circle-progress";
import { DatePipe } from "@angular/common";
import { ConfigurationComponent } from './component/feature/configuration/configuration.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: "#ffffff",
  bgsOpacity: 0.5,
  bgsPosition: POSITION.centerCenter,
  bgsSize: 50,
  bgsType: SPINNER.threeBounce,
  blur: 10,
  delay: 0,
  fastFadeOut: true,
  fgsColor: "#ffffff",
  fgsPosition: POSITION.centerCenter,
  fgsSize: 50,
  fgsType: SPINNER.threeBounce,
  gap: 0,
  logoPosition: POSITION.centerCenter,
  logoSize: 100,
  logoUrl: "assets/images/olios_logo.png",
  masterLoaderId: "master",
  overlayBorderRadius: "0",
  overlayColor: "rgba(30,30,47,0.9)",
  pbColor: "#ffffff",
  pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 3,
  hasProgressBar: false,
  text: "",
  textColor: "#FFFFFF",
  textPosition: POSITION.centerCenter,
  maxTime: -1,
  minTime: 300
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FooterComponent,
    HeaderComponent,
    AddNewPasswordComponent,
    ForgotPasswordComponent,
    ForgetUsernameComponent,
    RoleComponent,
    PrivilegeComponent,
    MenuPrivilegeDialogComponent,
    RolePrivilegeDialogComponent,
    ShiftDetailsComponent,
    SearchLprViolationDialogComponent,
    ResetPasswordDialogComponent,
    ResetPasswordVerify,
    InteractiveGeofenceComponent,
    ZoneManagementComponent,
    ZoneAddDialogComponent,
    ZoneUpdateDialogComponent,
    GeofenceComponent,
    GeofenceAddDialogComponent,
    GeofenceUpdateDialogComponent,
    ZoneViewDialogComponent,
    PaymentDetailSearchComponent,
    InteractiveZoneComponent,
    AllGeofenceComponent,
    NumplatePaymentSearchComponent,
    NumplatePermitSearchComponent,
    PaymentApiNumplateSearchComponent,
    ChartShiftDetailComponent,
    DashboardSuperComponent,
    DashboardOrganizationComponent,
    ChartDailyShiftDetailsComponent,
    GeofenceFileUploaderComponent,
    ZoneFileUploaderComponent,
    GeofenceDetailFileUploaderComponent,
    CitationManagementComponent,
    CitationViewDialogComponent,
    EnforcementVehicleComponent,
    VehicleAddDialogComponent,
    VehicleUpdateDialogComponent,
    EventManagementComponent,
    EventPeoDialogComponent,
    PaymentsTestingComponent,
    PaymentTestingFileUploaderComponent,
    DashboardComponent,
    ConfigurationComponent
  ],
  imports: [
    AppRoutingModule,
    DragDropModule,
    BrowserModule,
    MatSortModule,
    ChartsModule,
    MatTableModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    Ng2SearchPipeModule,
    ReactiveFormsModule,
    MatarialModule,
    AgmCoreModule.forRoot({
      apiKey: environment.MAP_API,
      libraries: ['places', 'drawing', 'geometry', 'visualization']
    }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      excludeRegexp: [
        "/api/lpr-raw/find-raw-data-images-by-sessionId/"
      ],
      showForeground:true,
      }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: "toast-bottom-left",
      preventDuplicates: false,
      disableTimeOut: false,
      easeTime: 500,
      //extendedTimeOut: 40000,
      newestOnTop: false,
      closeButton: true,
      maxOpened: 4,
      tapToDismiss: true,
    }),
   

    NgCircleProgressModule.forRoot({
      // set defaults here

    })

  ],
  providers: [
    AuthenticationService,
    TokenStorage,
    ToastrService,
    WebUtil,
    ToastrUtil,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
